(function() {
    'use strict';

    angular
        .module('mVtasWebApp')
        .controller('ZetasrealtimeDialogController', ZetasrealtimeDialogController);

    ZetasrealtimeDialogController.$inject = ['$timeout', '$scope', '$stateParams', '$uibModalInstance', 'entity', 'Zetasrealtime'];

    function ZetasrealtimeDialogController ($timeout, $scope, $stateParams, $uibModalInstance, entity, Zetasrealtime) {
        var vm = this;

        vm.zetasrealtime = entity;
        vm.clear = clear;
        vm.datePickerOpenStatus = {};
        vm.openCalendar = openCalendar;
        vm.save = save;

        $timeout(function (){
            angular.element('.form-group:eq(1)>input').focus();
        });

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function save () {
            vm.isSaving = true;
            if (vm.zetasrealtime.id !== null) {
                Zetasrealtime.update(vm.zetasrealtime, onSaveSuccess, onSaveError);
            } else {
                Zetasrealtime.save(vm.zetasrealtime, onSaveSuccess, onSaveError);
            }
        }

        function onSaveSuccess (result) {
            $scope.$emit('mVtasWebApp:zetasrealtimeUpdate', result);
            $uibModalInstance.close(result);
            vm.isSaving = false;
        }

        function onSaveError () {
            vm.isSaving = false;
        }

        vm.datePickerOpenStatus.fechadesde = false;
        vm.datePickerOpenStatus.fechahasta = false;
        vm.datePickerOpenStatus.fechaoperativa = false;

        function openCalendar (date) {
            vm.datePickerOpenStatus[date] = true;
        }
    }
})();
